import React from 'react'
import ReactDOM from 'react-dom'
import App from './app'
import './styles/index.css'
import { AuthContextProvider } from './contexts/google-auth'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { IntlProvider } from 'react-intl'
import locale from 'localization'
import { ThemeProvider } from './contexts/theme-context'

const language = 'en'
const queryClient = new QueryClient()
queryClient.setDefaultOptions({
  queries: {
    retry: false,
    refetchOnWindowFocus: false,
  },
})

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthContextProvider>
        <QueryClientProvider client={queryClient}>
          <IntlProvider
            locale={language}
            messages={locale[language]}
            key={language}
          >
            <ReactQueryDevtools />
            <App />
          </IntlProvider>
        </QueryClientProvider>
      </AuthContextProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
)
